import { stateKey } from './actions'

export const selectIsAuthenticated = (state) => state[stateKey].isAuthenticated
export const selectIsImpersonated = (state) => state[stateKey].isImpersonated
export const selectErrorMessage = (state) => state[stateKey].errorMessage
export const selectResetPasswordSuccess = (state) => state[stateKey].isSendingSuccessReset
